import { user_api } from '../api/user';

export const user_controller = {
  get_settings (axios, params) {
    params = params || {};
    return axios.$get(user_api.settings, { params });
  },
  put_settings (axios, params) {
    params = params || {};
    return axios.$put(user_api.settings, params);
  },
};
